var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import { connect } from "@irati/store";
import id from "@irati/utils/id";
import Wrapper from "../Wrapper";
import Location from "../Location";
import Online from "../Online";
import SecondaryDetailsItem from "../Item";
import { StyledRouterLink, StyledIconText } from "./styled/Cashback";
var Cashback = /** @class */ (function (_super) {
    __extends(Cashback, _super);
    function Cashback() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getTransactionDescription = function (transactionAmount, lastFour, currency) {
            if (!transactionAmount || !lastFour || !currency) {
                return null;
            }
            return (React.createElement(FormattedMessage, { id: "wallet.secondaryDetails.perksGO.cashback.transactionDescription", values: {
                    amount: _this.props.intl.formatNumber(transactionAmount, { style: "currency", currency: currency }),
                    lastFour: lastFour
                } }));
        };
        return _this;
    }
    Cashback.prototype.render = function () {
        var _a = this.props, className = _a.className, data = _a.data, wallet = _a.wallet, formatMessage = _a.formatMessage;
        var apps = this.context.apps;
        var location = data.location, transactionAmount = data.transactionAmount, transactionDate = data.transactionDate, lastFour = data.lastFour, dealUrlSlug = data.dealUrlSlug, isPerksGoRetailDeal = data.isPerksGoRetailDeal;
        var currency = wallet.currency;
        var idNamespace = id("secondary-details-perksGO-cashback", this.props);
        var transactionDescriptionText = this.getTransactionDescription(transactionAmount, lastFour, currency);
        var formattedTransactionDate = moment(transactionDate).format("dddd, Do MMMM YYYY, h:mm A");
        return (React.createElement(Wrapper, { className: className, id: idNamespace },
            location && !isPerksGoRetailDeal && React.createElement(Location, { text: location }),
            isPerksGoRetailDeal && React.createElement(Online, { text: formatMessage({ id: "wallet.secondaryDetails.perksGO.cashback.onlineText" }) }),
            transactionDescriptionText && React.createElement(SecondaryDetailsItem, { text: transactionDescriptionText }),
            transactionDate && React.createElement(SecondaryDetailsItem, { text: formattedTransactionDate }),
            dealUrlSlug && (React.createElement(StyledRouterLink, { app: apps.PERKS, to: "/info/" + dealUrlSlug, id: id("deal-button", idNamespace), uppercase: false },
                React.createElement(StyledIconText, { icon: "angleRight", iconPosition: "right" },
                    React.createElement(FormattedMessage, { id: "wallet.secondaryDetails.perksGO.cashback.dealButtonText" }))))));
    };
    Cashback.contextTypes = {
        apps: PropTypes.object.isRequired
    };
    return Cashback;
}(PureComponent));
var mapStateToProps = function (_a) {
    var wallet = _a.wallet;
    return ({
        wallet: wallet
    });
};
export default injectIntl(connect(mapStateToProps)(Cashback));
